// Endorsement-specific form built on top of generic MarkdownEntryForm
import { MarkdownEntryForm, type MarkdownEntryFormProps } from './MarkdownEntryForm';
import { ENDORSEMENT_VALIDATION } from '@promo/shared';

type EndorsementFormProps = Omit<MarkdownEntryFormProps, 'label' | 'placeholder'>;

export function EndorsementForm({
  /** Initial content for editing an existing endorsement */
  initialContent = '',
  /** Called when user saves the endorsement */
  onSubmit,
  /** Called when user cancels adding/editing */
  onCancel,
  /** Called when user confirms deletion of an endorsement */
  onDelete,
  /** Disable interactions when submitting */
  isSubmitting = false,
  /** Disable editing and interactions, display only */
  readOnly = false,
  startInEditMode = false,
}: EndorsementFormProps) {
  return (
    <MarkdownEntryForm
      label="Endorsement"
      placeholder="Provide the endorsement with detailed examples of how the candidate met the criteria to be promoted"
      initialContent={initialContent}
      onSubmit={onSubmit}
      onCancel={onCancel}
      onDelete={onDelete}
      isSubmitting={isSubmitting}
      readOnly={readOnly}
      startInEditMode={startInEditMode}
      maxLength={ENDORSEMENT_VALIDATION.MAX_CONTENT_LENGTH}
    />
  );
}
